import React, { useState, useEffect } from 'react';
import { useData } from '../../context/DataContext';
import { Save, RotateCcw } from 'lucide-react';

const AdminSettings = () => {
  const { siteSettings, updateSiteSettings, resetToSeed } = useData();
  const [formData, setFormData] = useState({});
  const [showResetConfirm, setShowResetConfirm] = useState(false);

  useEffect(() => {
    if (siteSettings) {
      setFormData(siteSettings);
    }
  }, [siteSettings]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('stats.')) {
      const statKey = name.split('.')[1];
      setFormData((prev) => ({
        ...prev,
        stats: { ...prev.stats, [statKey]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateSiteSettings(formData);
    alert('Ayarlar kaydedildi!');
  };

  const handleReset = () => {
    resetToSeed();
    setShowResetConfirm(false);
    window.location.reload();
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
        <h1 className="text-2xl font-bold text-white">Site Ayarları</h1>
        <button
          onClick={() => setShowResetConfirm(true)}
          className="flex items-center space-x-2 px-4 py-2 text-red-400 border border-red-400/30 rounded hover:bg-red-400/10 transition-colors duration-300"
        >
          <RotateCcw className="w-5 h-5" />
          <span>Varsayılana Sıfırla</span>
        </button>
      </div>

      <form onSubmit={handleSubmit} className="max-w-4xl space-y-8">
        {/* Contact Info */}
        <div className="bg-anthracite-light rounded-lg border border-gold/10 p-6">
          <h2 className="text-lg font-semibold text-white mb-6">İletişim Bilgileri</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm text-gray-400 mb-2">Telefon 1</label>
              <input
                type="text"
                name="phone1"
                value={formData.phone1 || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-anthracite border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-2">Telefon 2</label>
              <input
                type="text"
                name="phone2"
                value={formData.phone2 || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-anthracite border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-2">WhatsApp Numarası</label>
              <input
                type="text"
                name="whatsappNumber"
                value={formData.whatsappNumber || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-anthracite border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300"
                placeholder="905xxxxxxxxx (başında 90 olmalı)"
              />
              <p className="text-xs text-gray-500 mt-1">Format: 90 + telefon numarası (boşluksuz)</p>
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-2">E-posta</label>
              <input
                type="email"
                name="email"
                value={formData.email || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-anthracite border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300"
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm text-gray-400 mb-2">Adres</label>
              <textarea
                name="address"
                value={formData.address || ''}
                onChange={handleChange}
                rows={2}
                className="w-full px-4 py-3 bg-anthracite border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300 resize-none"
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm text-gray-400 mb-2">Instagram URL</label>
              <input
                type="url"
                name="instagram"
                value={formData.instagram || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-anthracite border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300"
              />
            </div>
          </div>
        </div>

        {/* About */}
        <div className="bg-anthracite-light rounded-lg border border-gold/10 p-6">
          <h2 className="text-lg font-semibold text-white mb-6">Hakkımızda</h2>
          
          <div className="space-y-6">
            <div>
              <label className="block text-sm text-gray-400 mb-2">Slogan</label>
              <input
                type="text"
                name="slogan"
                value={formData.slogan || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-anthracite border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-2">Kısa Açıklama</label>
              <textarea
                name="aboutShort"
                value={formData.aboutShort || ''}
                onChange={handleChange}
                rows={3}
                className="w-full px-4 py-3 bg-anthracite border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300 resize-none"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-2">Detaylı Açıklama</label>
              <textarea
                name="aboutLong"
                value={formData.aboutLong || ''}
                onChange={handleChange}
                rows={6}
                className="w-full px-4 py-3 bg-anthracite border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300 resize-none"
              />
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="bg-anthracite-light rounded-lg border border-gold/10 p-6">
          <h2 className="text-lg font-semibold text-white mb-6">İstatistikler</h2>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div>
              <label className="block text-sm text-gray-400 mb-2">Tecrübe (Yıl)</label>
              <input
                type="text"
                name="stats.experience"
                value={formData.stats?.experience || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-anthracite border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300"
                placeholder="20+"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-2">Tamamlanan Proje</label>
              <input
                type="text"
                name="stats.completedProjects"
                value={formData.stats?.completedProjects || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-anthracite border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300"
                placeholder="50+"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-2">Toplam Daire</label>
              <input
                type="text"
                name="stats.totalUnits"
                value={formData.stats?.totalUnits || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-anthracite border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300"
                placeholder="2000+"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-2">Mutlu Aile</label>
              <input
                type="text"
                name="stats.happyFamilies"
                value={formData.stats?.happyFamilies || ''}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-anthracite border border-gold/20 rounded text-white focus:border-gold focus:outline-none transition-colors duration-300"
                placeholder="1500+"
              />
            </div>
          </div>
        </div>

        {/* Submit */}
        <div className="flex justify-end">
          <button
            type="submit"
            className="flex items-center space-x-2 px-6 py-3 bg-gold text-anthracite font-semibold rounded hover:bg-gold-light transition-colors duration-300"
          >
            <Save className="w-5 h-5" />
            <span>Değişiklikleri Kaydet</span>
          </button>
        </div>
      </form>

      {/* Reset Confirmation Modal */}
      {showResetConfirm && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-anthracite-light rounded-lg border border-gold/20 p-6 max-w-md w-full">
            <h3 className="text-lg font-semibold text-white mb-4">Varsayılana Sıfırla</h3>
            <p className="text-gray-400 mb-6">
              Tüm veriler başlangıç değerlerine sıfırlanacak. Bu işlem geri alınamaz. Emin misiniz?
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setShowResetConfirm(false)}
                className="px-4 py-2 text-gray-400 hover:text-white transition-colors duration-300"
              >
                İptal
              </button>
              <button
                onClick={handleReset}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors duration-300"
              >
                Sıfırla
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminSettings;